<template>
  <v-container class="fill-height eservice_type" fluid>
    <v-layout class="eservice_inner_wrap login_wrap type2">
      <v-flex class="pa-0 login_content type2">
        <ValidationObserver ref="observer">
          <v-form>
            <v-card class="login_form type2 type3" flat style="min-width : 800px;">
              <h2 class="logo mb-25"><v-img src="~@/assets/img/logo_auth.png" alt="EGPO"></v-img></h2>
              <h3 class="out_title mb-15">{{ $t('signin.proof_document.title') }}</h3>

              <v-card-text class="pa-0 inner_item_content mt-20">
                <h2 class="inner_title mb-10">{{ $t('signin.proof_document.fields.title_msg') }}</h2>
                <v-row class="ma-0" v-if="user_group_type_code == '3802' || user_group_type_code == '3804'">
                  <v-col cols="4" class="pa-0">
                    <h2 class="nec_title pt-15"><i>*</i> {{ $t('signin.proof_document.fields.company_registration_documents') }}</h2>
                  </v-col>
                  <v-col cols="8" class="pa-0">
                    <div class="input_text_type_basic file_type pl-10 fileForm">
                      <ValidationProvider v-slot="{ errors }" :name="$t('signin.proof_document.fields.company_registration_documents')" :rules="{required: true}">
                        <v-file-input
                          outlined
                          dense
                          :placeholder="$t('common.common.no_files_selected')"
                          :prepend-icon="$t('common.common.select_file')"
                          class="ft-size12 br_none wp100"
                          accept=".pdf, .jpg, .gif"
                          v-model="company_reg_file"
                          style="height: 40px"
                          :error-messages="errors"
                          @change="fnUploadCompanyRegFile()"
                          clearable
                          @click:clear="fnInitCompanyRegFile()"
                        >
                        </v-file-input>
                      </ValidationProvider>
                    </div>
                  </v-col>
                </v-row>
                <v-row class="ma-0 mt-35">
                  <v-col cols="4" class="pa-0">
                    <h2 class="nec_title pt-15"><i>*</i> {{ $t('signin.proof_document.fields.id_card_or_passport') }}</h2>
                  </v-col>
                  <v-col cols="8" class="pa-0">
                    <div class="input_text_type_basic file_type pl-10 fileForm">
                      <ValidationProvider v-slot="{ errors }" :name="$t('signin.proof_document.fields.id_card_or_passport')" :rules="{required: true}">
                        <v-file-input
                          outlined
                          dense
                          :placeholder="$t('common.common.no_files_selected')"
                          :prepend-icon="$t('common.common.select_file')"
                          class="ft-size12 br_none wp100"
                          accept=".pdf, .jpg, .gif"
                          v-model="id_card_file"
                          style="height: 40px"
                          @change="fnUploadIDFile()"
                          clearable
                          @click:clear="fnInitIDFile()"
                          :error-messages="errors"
                        >
                        </v-file-input>
                      </ValidationProvider>
                    </div>
                  </v-col>
                </v-row>
                <v-row class="ma-0 mt-35" v-if="user_type_code === '2705'">
                  <v-col cols="4" class="pa-0">
                    <h2 class="nec_title mb-15"><i>*</i> {{ $t('signin.proof_document.fields.student_id_card') }}</h2>
                  </v-col>
                  <v-col cols="8" class="pa-0">
                    <div class="input_text_type_basic file_type pl-10 fileForm">
                      <ValidationProvider v-slot="{ errors }" :name="$t('signin.proof_document.fields.student_id_card')" :rules="{required: true}">
                        <v-file-input
                          outlined
                          dense
                          :placeholder="$t('common.common.no_files_selected')"
                          :prepend-icon="$t('common.common.select_file')"
                          class="ft-size12 br_none wp100"
                          accept=".pdf, .jpg, .gif"
                          v-model="student_id_file"
                          style="height: 40px"
                          @change="fnUploadStudentIdFile()"
                          clearable
                          @click:clear="fnInitStudentIdFile()"
                          :error-messages="errors"
                        >
                        </v-file-input>
                      </ValidationProvider>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions class="pl-0 pr-0 mt-25">
                <v-spacer></v-spacer>
                <v-btn
                  dense
                  height="50"
                  width="150"
                  color="#f2f2f2"
                  class="btn-normal br_none"
                  @click="fnGoMain()"
                  v-if="ind_update_cert === 'Y' || user_status_type_code === '3530'"
                >
                  {{ $t('signin.proof_document.fields.next_time') }}
                </v-btn>
                <v-spacer class="hidden_lr5"></v-spacer>
                <v-btn
                  dense
                  height="50"
                  width="150"
                  dark
                  color="#2a58ad"
                  class="btn-normal br_none"
                  @click="fnSave()"
                >
                  {{ $t('common.button.submit') }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-form>
        </ValidationObserver>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import requestApi from '@/utils/requestApi'
import utils from '@/utils/utils'
import eventBus from '@/utils/eventBus'
import store from '@/store'
import { ValidationObserver, ValidationProvider } from 'vee-validate'

export default {
  name: 'ProofDocument',
  components: {
    ValidationObserver,
    ValidationProvider
  },
  data () {
    return {
      company_reg_file : null,
      id_card_file : null,
      student_id_file: null,
      user_group_type_code : store.state.token.user_group_type_code,
      user_status_type_code : store.state.token.user_status_type_code,
      user_type_code: store.state.token.user_type_code,

      registry_cert_file_key : '',
      id_card_file_key : '',
      student_id_file_key: '',
      ind_update_cert: store.state.token.ind_update_cert
    }
  },
  mounted () {
    window.scrollTo(0, 0)
    // 로그인 정보가 없으면 로그 아웃 처리
    if(utils.isNull(this.user_status_type_code)){
      this.fnSignOut()
    }
  },
  methods: {
    fnGoMain(){
      this.$router.push('/main')
    },
    fnSave(){
      this.$refs.observer.validate().then((valid) => {
        if(valid){
          let params = {
            registry_cert_file_key: this.registry_cert_file_key,
            id_card_file_key: this.id_card_file_key,
            student_id_file_key: this.student_id_file_key
          }

          requestApi({
            url: '/user/profile/proof',
            method: 'PUT',
            data : params,
            callback: (res) => {
              if (res.res_code === '200') {
                // 인증 만료 회원인 경우 또는 Over Due 상태인 회원은 로그아웃 처리
                if (this.ind_update_cert === 'E' ||
                  this.user_status_type_code === '3506' ||
                  this.user_status_type_code === '3507' ||
                  this.user_status_type_code === '3508' ) {
                  // 로그아웃
                  this.fnSignOut()
                } else {
                  this.$router.push('/main')
                }
              }else{
                if (res.res_code === '401012') {
                  utils.setTokenRefresh().then(() => {
                    this.fnSave()
                  })
                } else {
                  eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
                }
              }
            }
          })
        }
      })
    },

    fnInitCompanyRegFile() {
      this.registry_cert_file_key = ''
      this.company_reg_file = null
    },

    fnUploadCompanyRegFile(){
      if(!utils.isNull(this.company_reg_file)){
        let formData = new FormData()
        formData.append("file_data", this.company_reg_file)

        requestApi({
          url: '/file/documents/upload',
          method: 'POST',
          data: formData,
          headers : {"Content-Type":"multipart/form-data"},
          callback: (res) => {
            // 파일저장
            if (res.res_code === '200') {
              this.registry_cert_file_key = res.data.file_key
            }else{
              if (res.res_code === '401012') {
                utils.setTokenRefresh().then(() => {
                  this.fnUploadCompanyRegFile()
                })
              } else {
                eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
                this.registry_cert_file_key = ''
                this.company_reg_file = null
              }
            }
          }
        })
      }
    },
    fnInitIDFile() {
      this.id_card_file = null
      this.id_card_file_key = ''
    },
    fnUploadIDFile(){
      if(!utils.isNull(this.id_card_file)){
        let extList = []
        extList.push({name_en: 'pdf'})
        extList.push({name_en: 'jpg'})
        extList.push({name_en: 'gif'})

        if (utils.getFileExtLen(this.id_card_file, extList, this.$t('common.message.file_extension_error')) === -1) {
          setTimeout(() => {
            this.id_card_file = null
            this.id_card_file_key = ''
          }, 100)

          return
        }

        let formData = new FormData()
        formData.append("file_data", this.id_card_file)

        requestApi({
          url: '/file/documents/upload',
          method: 'POST',
          data: formData,
          headers : {"Content-Type":"multipart/form-data"},
          callback: (res) => {
            // 파일저장
            if (res.res_code === '200') {
              this.id_card_file_key = res.data.file_key
            }else{
              if (res.res_code === '401012') {
                utils.setTokenRefresh().then(() => {
                  this.fnUploadIDFile()
                })
              } else {
                eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
                this.id_card_file_key = ''
                this.id_card_file = null
              }
            }
          }
        })
      }
    },

    fnInitStudentIdFile() {
      this.student_id_file_key = ''
      this.student_id_file = null
    },

    fnUploadStudentIdFile(){
      if(!utils.isNull(this.student_id_file)){
        let extList = []
        extList.push({name_en: 'pdf'})
        extList.push({name_en: 'jpg'})
        extList.push({name_en: 'gif'})

        if (utils.getFileExtLen(this.student_id_file, extList, this.$t('common.message.file_extension_error')) === -1) {
          setTimeout(() => {
            this.student_id_file_key = ''
            this.student_id_file = null
          }, 100)

          return
        }

        let formData = new FormData()
        formData.append("file_data", this.student_id_file)

        requestApi({
          url: '/file/documents/upload',
          method: 'POST',
          data: formData,
          headers : {"Content-Type":"multipart/form-data"},
          callback: (res) => {
            // 파일저장
            if (res.res_code === '200') {
              this.student_id_file_key = res.data.file_key
            }else{
              if (res.res_code === '401012') {
                utils.setTokenRefresh().then(() => {
                  this.fnUploadStudentIdFile()
                })
              } else {
                eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
                this.student_id_file_key = ''
                this.student_id_file = null
              }
            }
          }
        })
      }
    },

    // Sign Out
    fnSignOut () {
      requestApi({
        url: '/autho/logout',
        method: 'GET',
        callback: (res) => {
          // logout 에서는 token 관련 오류도 logout 과 동일하게 처리
          if (res.res_code === '200' || res.res_code === '401011' || res.res_code === '401013' || res.res_code === '401014') {
            // store 정보 초기화
            store.dispatch('SetInitToken')
            store.dispatch('SetInitAuthHeader')

            // 읽지 않은 통지서 개수 초기화
            eventBus.$emit('NOTIFICATION_INIT')

            // unpaymnet 개수 초기화
            eventBus.$emit('PAYMENT_INIT')

            let option = {
              text: this.$t('signin.proof_document.fields.re_login_msg')
            }
            eventBus.$emit('SHOW_SNACKBAR', option)

            // 로그인 페이지로 이동
            this.$router.push('/signin')
          } else {
            eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
          }
        }
      })
    }

  }

}
</script>
